
import React from 'react';
import { UCAModule, CommonModule } from "uca-react-containers-library";
import { useLocation } from 'react-router-dom';

const UnSubscribeInterstitialComponent = () => {
    const { appData } = CommonModule.useApp();
    const location = useLocation();
    const queryString = location.search;
    const regexProgramType = /programType=vc/;
    const hasVCProgramType = regexProgramType.test(queryString);
    const regexActionOptIn = /action=optIn/;
    const hasVCActionOptIn = regexActionOptIn.test(queryString);
    const regexActionOptOut = /action=optOut/;
    const hasVCActionOptOut = regexActionOptOut.test(queryString);

    document.title = `Unsubscribe | ${appData.banner}`;
    React.useEffect(() => {
    }, []);

    if (hasVCProgramType && hasVCActionOptIn) {
        return (
            <CommonModule.ViewportProvider>
                <div class="col-lg-3 col-xl-4"></div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
                    <UCAModule.VineAndCellarOptIn />
                </div>
            </CommonModule.ViewportProvider>
        );
    } else if (hasVCProgramType && hasVCActionOptOut) {
        return (
            <CommonModule.ViewportProvider>
                <div class="col-lg-3 col-xl-3"></div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
                    <UCAModule.VineAndCellarOptOut />
                </div>
            </CommonModule.ViewportProvider>
        );
    } else {
        return (
            <CommonModule.ViewportProvider>
                <div class="col-lg-3 col-xl-3"></div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
                    <UCAModule.UnsubscribeInterstitial />
                </div>
            </CommonModule.ViewportProvider>
        );
      }
};

export default UnSubscribeInterstitialComponent;




